var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import React, { useContext } from 'react';
import { Context } from '../context';
function IconLoadingComponent(props, ref) {
  var prefixFromContext = useContext(Context).prefix;
  var _a = props.className,
    className = _a === void 0 ? '' : _a,
    prefixFromProps = props.prefix,
    _b = props.width,
    width = _b === void 0 ? '1em' : _b,
    _c = props.height,
    height = _c === void 0 ? '1em' : _c,
    _d = props.useCurrentColor,
    useCurrentColor = _d === void 0 ? true : _d,
    rest = __rest(props, ["className", "prefix", "width", "height", "useCurrentColor"]);
  var prefix = prefixFromProps || prefixFromContext || 'arco';
  return /*#__PURE__*/React.createElement("svg", __assign({
    className: "".concat(prefix, "-icon ").concat(prefix, "-icon-loading ").concat(className),
    width: width,
    height: height,
    viewBox: "0 0 16 16",
    fill: useCurrentColor ? 'currentColor' : '#000',
    xmlns: "http://www.w3.org/2000/svg"
  }, rest, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 7.99984C14.6667 11.6817 11.682 14.6665 8.00008 14.6665C4.31818 14.6665 1.33342 11.6817 1.33342 7.99984C1.33342 7.63165 1.63189 7.33317 2.00008 7.33317C2.36827 7.33317 2.66675 7.63165 2.66675 7.99984C2.66675 10.9454 5.05456 13.3332 8.00008 13.3332C10.9456 13.3332 13.3334 10.9454 13.3334 7.99984C13.3334 5.05432 10.9456 2.6665 8.00008 2.6665C6.74296 2.6665 5.58907 3.10061 4.6775 3.82763C4.38965 4.0572 3.97019 4.00996 3.74062 3.72211C3.51104 3.43425 3.55829 3.01479 3.84614 2.78522C4.98534 1.87665 6.43016 1.33317 8.00008 1.33317C11.682 1.33317 14.6667 4.31794 14.6667 7.99984Z",
    fillOpacity: "1"
  }));
}
var IconLoading = /*#__PURE__*/React.forwardRef(IconLoadingComponent);
export default IconLoading;